import {
  vCountryAny,
  vDateUtcNoon,
  vEmailOrEmpty,
  vNumber,
  vObject,
  vOptional,
  vOptionalDef,
  type vOutput,
  vPhoneExt,
  vPhoneNumber,
  vPicklist,
  vPostalCode,
  vString,
} from '../../validation/index.ts'
import { packagingTypes } from '../packaging-type.ts'
import {
  defaultFlagSchema,
  type EntriesWithSuffix,
  intSchema,
  selectQuoteSchema,
  strictCloseDockHoursSchema,
  strictOpenDockHoursSchema,
} from './common.ts'

const parcelFlatItemSchema = vObject({
  itemDescription: vOptional(vString()),
  itemWeight: vOptional(intSchema),
  itemLength: vOptional(intSchema),
  itemWidth: vOptional(intSchema),
  itemHeight: vOptional(intSchema),
  itemPackagingType: vOptional(
    vPicklist(
      packagingTypes.filter(p => p.modes.includes('parcel')).map(p => p.key),
    ),
  ),
  itemNonStandardFlag: defaultFlagSchema,
  itemDeclaredValue: vOptional(vNumber()),
})

const getItemSchema = <Suffix extends string>(suffix: Suffix) => {
  return vObject<
    EntriesWithSuffix<typeof parcelFlatItemSchema.entries, Suffix>
  >(
    Object.entries(parcelFlatItemSchema.entries).reduce((acc, [key, value]) => {
      acc[`${key}${suffix}`] = value
      return acc
    }, {} as any),
  )
}

export const parcelFlatLoadSchema = vObject({
  pickupDate: vDateUtcNoon(),
  schedulePickupFlag: defaultFlagSchema,
  ...selectQuoteSchema.entries,
  originCompany: vOptional(vString()),
  originAddress: vOptional(vString()),
  originAddress2: vOptional(vString()),
  originCity: vOptional(vString()),
  originState: vOptional(vString()),
  originPostalCode: vPostalCode(),
  originCountry: vOptionalDef(vCountryAny, 'us'),
  originResidentialFlag: defaultFlagSchema,
  originContactName: vOptional(vString()),
  originContactPhone: vOptional(vPhoneNumber()),
  originContactPhoneExt: vOptional(vPhoneExt()),
  originContactEmail: vOptional(vEmailOrEmpty),
  originReferenceNumber: vOptional(vString()),
  originInstructions: vOptional(vString()),
  originReadyTime: strictOpenDockHoursSchema,
  originCloseTime: strictCloseDockHoursSchema,
  destCompany: vOptional(vString()),
  destAddress: vOptional(vString()),
  destAddress2: vOptional(vString()),
  destCity: vOptional(vString()),
  destState: vOptional(vString()),
  destPostalCode: vPostalCode(),
  destCountry: vOptionalDef(vCountryAny, 'us'),
  destResidentialFlag: defaultFlagSchema,
  destContactName: vOptional(vString()),
  destContactPhone: vOptional(vPhoneNumber()),
  destContactPhoneExt: vOptional(vPhoneExt()),
  destContactEmail: vOptional(vEmailOrEmpty),
  destReferenceNumber: vOptional(vString()),
  destInstructions: vOptional(vString()),
  signatureRequiredFlag: defaultFlagSchema,
  adultSignatureRequiredFlag: defaultFlagSchema,
  indirectSignatureRequiredFlag: defaultFlagSchema,
  // This is gross, but I can't get the types to work with a loop or mapped type
  ...getItemSchema('1').entries,
  ...getItemSchema('2').entries,
  ...getItemSchema('3').entries,
  ...getItemSchema('4').entries,
  ...getItemSchema('5').entries,
  ...getItemSchema('6').entries,
  ...getItemSchema('7').entries,
  ...getItemSchema('8').entries,
  ...getItemSchema('9').entries,
  ...getItemSchema('10').entries,
  ...getItemSchema('11').entries,
  ...getItemSchema('12').entries,
  ...getItemSchema('13').entries,
  ...getItemSchema('14').entries,
  ...getItemSchema('15').entries,
  ...getItemSchema('16').entries,
  ...getItemSchema('17').entries,
  ...getItemSchema('18').entries,
  ...getItemSchema('19').entries,
  ...getItemSchema('20').entries,
  ...getItemSchema('21').entries,
  ...getItemSchema('22').entries,
  ...getItemSchema('23').entries,
  ...getItemSchema('24').entries,
  ...getItemSchema('25').entries,
  ...getItemSchema('26').entries,
  ...getItemSchema('27').entries,
  ...getItemSchema('28').entries,
  ...getItemSchema('29').entries,
  ...getItemSchema('30').entries,
  ...getItemSchema('31').entries,
  ...getItemSchema('32').entries,
  ...getItemSchema('33').entries,
  ...getItemSchema('34').entries,
  ...getItemSchema('35').entries,
})

export type ParcelFlatLoad = vOutput<typeof parcelFlatLoadSchema>
